<section class="resume-section p-3 p-lg-5 d-flex flex-column" id="text">
  <div class="my-auto">
    <h2 class="mb-5">Text Analytics</h2>
    <form (ngSubmit)="onSubmit(textForm.value.textData)" #textForm="ngForm">
      <div
        id="text-data"
        ngModelGroup="textData"
        #textData="ngModelGroup">

        <div class="form-group">

          <label for="content">Text Features</label>
          <select class="form-control"
                  id="feature"
                  name="feature"
                  ngModel>
            <option value="lemmatize">Lemmatize</option>
            <option value="nouns">Nouns</option>
            <option value="entities">Entities</option>
          </select>
        </div>
        <div class="form-group">

          <label for="content">Text Content</label>
          <textarea  class="form-control"
                    id="content"
                    name="content" ngModel
                    rows="3">

          </textarea>
        </div>
<!--        <div class="form-group">-->
<!--          <re-captcha [(ngModel)]="declarativeFormCaptchaValue"-->
<!--                      name="captcha" required></re-captcha>-->
<!--        </div>-->

      </div>

      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="!textForm.valid">Submit</button>

    </form>
    <div class="form-group">
          <textarea rows="10" readonly class="form-control"
                    id="textCopy" [(ngModel)]="textResponse"></textarea>
      <button type="button" class="btn btn-outline-warning btn-sm" [cdkCopyToClipboard]="textResponse">Copy to clipboard</button>
    </div>

  </div>
</section>

